import * as table from "./TableData";
import { CurrentTime, GET_COMPANY_FROM_URL, IsSweetAndSnacksCompany, currentDate_dmy, loginUserDetails } from "../../../components/Common/CommonFunction";

export const pageBorder = (doc) => {
    doc.setDrawColor("black");
    doc.line(570, 17, 30, 17);
    doc.line(30, 815, 30, 17);
    doc.line(570, 815, 570, 17);
    doc.line(570, 815, 30, 815);
};

export const pageHeder = (doc) => {
    const logo = localStorage.getItem(`${GET_COMPANY_FROM_URL()}_CompanyLogo`);
    if (logo) {
        if (IsSweetAndSnacksCompany()) doc.addImage(logo, "PNG", 33, 18, 60, 40, null, "FAST");
        else doc.addImage(logo, "PNG", 33, -2, 80, 80, null, "FAST");
    }
    doc.setFont("Tahoma", "bold");
    doc.setFontSize(17);
    doc.text("CashBook Report", 250, 40);
};

export const reportHeder1 = (doc, data) => {
    doc.setFont("Tahoma", "bold");
    doc.setFontSize(11);
    const user = loginUserDetails();
    doc.text(`*** ${user.PartyName} ***`, 300, 75, "center");
    doc.line(570, 60, 30, 60);
    doc.line(570, 80, 30, 80);

    const labels = ["Cashier:   ", "Period:   "];
    const options = {
        showHead: "never",      // no green header row, labels are drawn inside the body row
        didDrawCell: (d) => {
            if (d.section === "body" && d.row.index === 0) {
                doc.setFontSize(9);
                doc.setFont(undefined, "bold");
                doc.text(labels[d.column.index], d.cursor.x + 2, d.cursor.y + 11);
            }
        },
        margin: { left: 30, right: 30, top: 55 },
        theme: "grid",
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: { top: 4, left: 52, right: 3, bottom: 4 },
            fontSize: 9,
            fontStyle: "normal",
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: { columnWidth: 232, halign: "left", cellPadding: { top: 4, left: 50, right: 3, bottom: 4 } },
            1: { columnWidth: 308, halign: "left", cellPadding: { top: 4, left: 46, right: 3, bottom: 4 } },
        },
        tableLineColor: "black",
        startY: 80,
    };
    doc.autoTable(table.PageHedercolumns, table.ReportHederRows(data), options);
};

export const tableBody = (doc, data) => {
    const options = {
        didParseCell: (d) => {
            if (d.section !== "body") return;
            // Particulars is now column 1
            if (table.isBalanceRow(String(d.row.cells[1].raw || ""))) {
                d.cell.styles.fontStyle = "bold";
                d.cell.styles.fontSize = 8;

            }
        },
        margin: { left: 30, right: 25, top: 85 },
        theme: "grid",
        headerStyles: {
            cellPadding: 4,
            lineWidth: 1,
            valign: "middle",
            fontStyle: "bold",
            halign: "center",
            fillColor: [235, 235, 235],
            textColor: [0, 0, 0],
            fontSize: 8,
            lineColor: [0, 0, 0],
        },
        bodyStyles: { textColor: [30, 30, 30], cellPadding: 4, fontSize: 8, lineColor: [0, 0, 0] },
        columnStyles: {
            0: { columnWidth: 75, halign: "center" },
            1: { columnWidth: 215, halign: "left" },
            2: { columnWidth: 80, halign: "right" },
            3: { columnWidth: 80, halign: "right" },
            4: { columnWidth: 90, halign: "right" },
        },
        tableLineColor: "black",
        startY: doc.autoTableEndPosY(),
    };
    doc.autoTable(table.columns, table.Rows(data), options);
};

export const pageFooter = (doc, data) => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        // page 1 already has its header and border; only add them to the following pages
        if (i > 1) {
            pageHeder(doc, data);
            pageBorder(doc);
        }
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(`Print Date : ${currentDate_dmy}   Time ${CurrentTime()}`, 30, 829);          // left edge of border
        doc.text(`Page ${i} of ${pageCount}`, 570, 829, { align: "right" });                   // right edge of border
    }
};